import React, { useState, useEffect } from "react"
import { EMERGENCY_TYPES_SEARCH } from "../../helpers/api_endpoints"
import { post } from "../../helpers/api_helper"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup,
} from "reactstrap"

import { Link, useLocation, useNavigate } from "react-router-dom"
import { Trans, useTranslation } from "react-i18next"
import Select from "react-select"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"

document.title = "Emergency Types"
function EmergencyTypesList() {
  const { i18n } = useTranslation()
  const [emergencyTypes, setEmergencyTypes] = useState([])
  const [successMsg, setSuccessMsg] = useState("")
  const [filters, setFilters] = useState({})
  const [title, setTitle] = useState("")
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getEmergencyTypes = async () => {
      try {
        const response = await post(
          `${EMERGENCY_TYPES_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`,
          filters
        )
        const data = response.data
        setEmergencyTypes(data.data)
        setTotalPages(data.pagination.totalPages)
        setPage(data.pagination.currentPage)
        setLoading(false)
      } catch (error) {
        console.log(error)
      }
    }
    getEmergencyTypes()
  }, [page, filters])

  const handleFilter = (type, value) => {
    const filtvalues = { ...filters }
    if (value === "") {
      delete filtvalues[type]
    } else {
      switch (type) {
        case "id":
          setTitle(value)
          filtvalues.name = value
          break
        case "title":
          setTitle(value)
          filtvalues.title = value
          break
        default:
          break
      }
    }
    setFilters(filtvalues)
  }

  const getTranslatedText = (titleData, defaultText = "") => {
    try {
      if (typeof titleData === "string") {
        try {
          const parsed = JSON.parse(titleData)
          if (Array.isArray(parsed?.title)) {
            const langMap = { en: 1, ar: 2, ur: 3, fa: 4, ps: 5 }
            const langKey = langMap[i18n.language] || 1
            const titleObj = parsed.title.find(item => item && item[langKey])
            return titleObj ? titleObj[langKey] : defaultText
          }
          return parsed.title || defaultText
        } catch (e) {
          return titleData || defaultText
        }
      }

      if (titleData && typeof titleData === "object") {
        return getTranslatedText(titleData.title, defaultText)
      }

      return defaultText
    } catch (error) {
      console.error("Error in getTranslatedText:", error)
      return defaultText
    }
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xl={12}>
              <Card>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}

                <CardTitle>
                  <Link to="/emergency-types/add">
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create</Trans>
                    </button>
                  </Link>
                </CardTitle>
                <div style={{ margin: "25px" }}>
                  <div className="row">
                    <div style={{ margin: "25px" }}>
                      <div className="row">
                        <div className="form-group col-md-3 mt-2">
                          <Label className="form-label">
                            <Trans>ID</Trans>
                          </Label>
                          <Input
                            name="id"
                            className="form-control"
                            placeholder=""
                            type="text"
                            onChange={e => handleFilter("id", e.target.value)}
                            onKeyDown={e => handleFilter("id", e.target.value)}
                          ></Input>
                        </div>
                        <div className="form-group col-md-3 mt-2">
                          <Label className="form-label">
                            <Trans>Title</Trans>
                          </Label>
                          <Input
                            name="title"
                            className="form-control"
                            placeholder=""
                            type="text"
                            onChange={e =>
                              handleFilter("title", e.target.value)
                            }
                            onKeyDown={e =>
                              handleFilter("title", e.target.value)
                            }
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <CardBody>
                      <div className="table-responsive">
                        <Table className="table table-striped table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>
                                <Trans>ID</Trans>
                              </th>
                              <th>
                                <Trans>Title</Trans>
                              </th>
                              <th>
                                <Trans>Icon</Trans>
                              </th>
                              <th>#</th>
                            </tr>
                          </thead>
                          <tbody>
                            {emergencyTypes.map((emergencyType, index) => (
                              <tr key={index}>
                                <td>{emergencyType.id}</td>
                                <td>
                                  {getTranslatedText(
                                    emergencyType.title,
                                    "No title available"
                                  )}
                                </td>
                                <td>
                                  <img
                                    src={emergencyType.icon}
                                    alt="icon"
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </td>
                                <td>
                                  <Link
                                    to={`/emergency-types/edit/${emergencyType.id}`}
                                  >
                                    <button className="btn btn-sm btn-info">
                                      <i className="dripicons-pencil"></i>{" "}
                                      &nbsp;
                                      <Trans>Edit</Trans>
                                    </button>
                                  </Link>{" "}
                                  &nbsp;
                                  <Link
                                    to={`/emergency-types/remove/${emergencyType.id}`}
                                  >
                                    <button className="btn btn-sm btn-danger">
                                      <i className="dripicons-trash"></i> &nbsp;
                                      <Trans>Remove</Trans>
                                    </button>
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <br></br>
                      <div className="text-center">
                        {/* Pagination controls */}
                        <button
                          className="btn btn-sm btn-dark"
                          onClick={handlePrevPage}
                          disabled={page === 1}
                        >
                          <Trans>Previous</Trans>
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-sm btn-dark"
                          onClick={handleNextPage}
                          disabled={page === totalPages}
                        >
                          <Trans>Next</Trans>
                        </button>
                      </div>
                    </CardBody>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EmergencyTypesList
